import { useState } from 'react'
import { WorkingDocumentContext } from '../contexts/WorkingDocumentContext'

interface WorkingDocumentProviderProps {
  children: React.ReactNode
}

export const WorkingDocumentProvider = ({ children }: WorkingDocumentProviderProps) => {
  const [isWorkingDocumentExcluded, setIsWorkingDocumentExcluded] = useState(true)

  return (
    <WorkingDocumentContext value={{ isWorkingDocumentExcluded, setIsWorkingDocumentExcluded }}>
      {children}
    </WorkingDocumentContext>
  )
}
